import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
  UncontrolledAlert,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { AppDispatch } from "src";
import { useDispatch, useSelector } from "react-redux";
import { addFinancing } from "src/slices/thunks";
import { createSelector } from "reselect";
import useToast from "src/components/Common/toast";

const NormalValidation = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { show, ToastComponent } = useToast();
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      descricao: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, insira o nome"),
      descricao: Yup.string().required("Por favor, insira a descrição"),
    }),
    onSubmit: async values => {
      await dispatch(addFinancing(values)).then(response => {
        if (
          typeof response.payload === "string" &&
          response.payload.includes("Request failed with")
        ) {
          show("Erro", "Erro ao criar financiador");
        } else {
          show("Sucesso", "Financiador criado com sucesso");
          validation.resetForm();
        }
      });
    },
  });

  return (
    <React.Fragment>
      {ToastComponent}
      <Col>
        <Card>
          <CardBody>
            <Form
              className="needs-validation"
              onSubmit={e => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom01">
                    Nome do Financiador
                  </Label>
                  <Input
                    name="name"
                    placeholder="Insira o nome do financiador"
                    type="text"
                    className="form-control"
                    id="validationCustom01"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom01">
                    Descrição do Financiador
                  </Label>
                  <Input
                    name="descricao"
                    type="textarea"
                    placeholder="Insira a descrição do financiador"
                    className="form-control"
                    id="validationCustom01"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.descricao || ""}
                    style={{ resize: "none" }}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.descricao &&
                  validation.errors.descricao ? (
                    <FormFeedback type="invalid">
                      {validation.errors.descricao}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              {/* <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="validationCustom03">Valor previsto</Label>
                  <Input
                    name="valor_previsto"
                    placeholder="Valor previsto (MZN)"
                    type="text"
                    className="form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.valor_previsto || ""}
                    invalid={
                      validation.touched.valor_previsto &&
                      validation.errors.valor_previsto
                        ? true
                        : false
                    }
                  />

                  {validation.touched.valor_previsto &&
                  validation.errors.valor_previsto ? (
                    <FormFeedback type="invalid">
                      {validation.errors.valor_previsto}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col> */}
              <Button color="primary" type="submit">Salvar</Button>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default NormalValidation;
